export default __webpack_public_path__ + "167acf0701846c7c287826f0683e2d41.png";